import { useEffect } from 'react'

export const useLoad = (fn, args) => {
  useEffect(() => {
    ;(async () => await fn())()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, args)
}
